<template>
  <el-dialog title="批量编辑" :visible.sync="visible" width="552px" :append-to-body="true" center class="pop-dialog">
    <div class="batch-con">
      <div class="con-title">每行对应一个选项</div>
      <el-input
        type="textarea"
        :rows="5"
        placeholder="请输入内容"
        v-model="textarea">
      </el-input>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="ok">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "popUserMore",
  components: {},
  data() {
    return {
      visible: false,
      textarea:''
    }
  },
  created() {

  },
  mounted() {
  },
  methods: {
    show(textarea) {
      this.visible = true
      this.textarea = textarea
    },
    ok() {
      this.visible = false
      this.$emit('ok',this.textarea)
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-con{
  .con-title{
    height: 30px;
    line-height: 30px;
    color: #939696;
  }
}
.pop-dialog /deep/ {
  .el-dialog__header {
    padding: 16px 0 0;
    height: 54px;
    box-sizing: border-box;
    .el-dialog__title{
      font-size: 16px;
    }
  }
  .el-textarea__inner{
    padding-left: 8px;
  }
  .el-dialog__body {
    padding: 0 72px 12px;
  }
  .el-dialog__footer {
    padding: 6px 0 16px;
  }
}
</style>
